<section class="project-overview-page">
  <app-header [showSideLinks]="false" />

  <main class="project-overview-page__content">
    <div class="project-overview-page__description">
      <p *ngFor="let paragraph of project().overview.description">
        {{ paragraph }}
      </p>
    </div>

    <div class="project-overview-page__grid">
      <div
        class="project-overview-page__item"
        *ngFor="let item of project().overview.items"
      >
        <div class="project-overview-page__label">
          {{ item.label }}
        </div>

        <div class="project-overview-page__value">
          <span *ngFor="let value of item.values">
            {{ value }}
          </span>
        </div>
      </div>
    </div>
  </main>

  <a
    class="project-overview-page__close"
    [routerLink]="['/project', project().slug]"
  >
    CLOSE
  </a>
</section>
